import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { StatusIndicator } from "@design-system/StatusIndicator/StatusIndicator";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import {
    isSuggestedSendingEmailRow,
    type SendingEmailRow,
} from "../sendingEmailsViewConfig";

export const DefaultCell = memo(
    ({ row }: CellContext<ViewTableFeatures, SendingEmailRow, boolean>) => {
        if (isSuggestedSendingEmailRow(row.original)) {
            return <ViewTableCell />;
        }

        return (
            <ViewTableCell>
                {row.original.isDefault ? (
                    <StatusIndicator
                        appearance="solid"
                        variant="blue"
                        label="Default"
                        showText
                    />
                ) : (
                    "-"
                )}
            </ViewTableCell>
        );
    },
);
